import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { moment } from "@msuite/utils/date";
import { useEffect } from "react";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

interface UseVehicleIntegrationOptions {
	startDate: string;
	endDate: string;
}

const defaultOptions: UseVehicleIntegrationOptions = {
	startDate: moment().startOf("year").db(),
	endDate: moment().endOf("year").db(),
};

export function useVehicleIntegration(vehicleId: string, options = defaultOptions) {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Computed */
	// Where the lorry is is part of reading the lorry, so the route is gated on `read Vehicle`. This
	// query polls every minute, which would make a caller without the rule toast a 403 once a minute
	// on a page they cannot read anyway. Rules still loading leave it enabled.
	const canRead = citadel ? citadel.can("read", "Vehicle") : true;

	/** Query */
	const query = useQuery({
		queryKey: [
			"vehicle",
			"integrations",
			"data",
			options.startDate,
			options.endDate,
			vehicleId || "",
		],
		queryFn: async () => {
			const response = await client.vehicles[":vehicleId"].integrations.$get({
				param: { vehicleId },
				query: options,
			});
			const data = await responseHandler(response);
			return data;
		},
		refetchInterval: 1000 * 60 * 1, // 1 Minute
		enabled: Boolean(vehicleId) && canRead,
	});

	useEffect(() => {});

	const hasIntegration = Boolean(query.data);

	return {
		...query,
		hasIntegration,
	};
}
